const ASSESS = '/assess';
const GROWUP = '/growup/childGrowthLog';

const Urls = {
  assess: {
    result: ASSESS + '/user/result',
    getShareUrl: ASSESS + '/user/getShareUrl',
    getShareResult: ASSESS + '/user/share/result',
    getSingleResult: ASSESS + '/user/singleResult',
    feedback: ASSESS + '/feedback/add'
  },
  growup: {
    graphContent: GROWUP + '/daily/graphContent',
    getShareDetail: GROWUP + '/daily/getShareDetail'
  },
  wx: {
    config: 'wxcityserver/getConfig'
  },
  user: {
    GET_USER_INFO: 'user/getUserInfo',
    UPDATE_TOKEN: 'user/updateWebLoginToken' // 更新token
  }
};

let apiUrl = {};
for (const key in Urls) {
  apiUrl = {...apiUrl, ...Urls[key]};
}
export {apiUrl};



// WEBPACK FOOTER //
// ./src/js/config/apiUrl.js